// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.errors[data-v-3bc76876]{\n    display: block!important;\n}\n", ""]);
// Exports
module.exports = exports;
